import { render, staticRenderFns } from "./UltimoAcesso.vue?vue&type=template&id=82efc1fe&"
import script from "./UltimoAcesso.vue?vue&type=script&lang=js&"
export * from "./UltimoAcesso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports